var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.855 20.55a9.544 9.544 0 0 1-1.352-.8l-.132-.097-.001-.001a9.588 9.588 0 0 1-2.816-3.298A9.39 9.39 0 0 1 2.5 12.002V12a9.5 9.5 0 0 1 19 0v.002a9.39 9.39 0 0 1-1.053 4.35 9.59 9.59 0 0 1-2.812 3.297 9.58 9.58 0 0 1-1.408.855h-.002l-.076.039h-.002a9.4 9.4 0 0 1-4.146.957h-.002a9.399 9.399 0 0 1-4.144-.95Zm.143-1.611-.232.45.455.226a8.514 8.514 0 0 0 7.558 0l.278-.138v-.436l-.055-.108A4.487 4.487 0 0 0 12 16.5a4.49 4.49 0 0 0-4.002 2.439Zm8.796-.637.3.532.461-.399.008-.006.009-.008.017-.015a8.5 8.5 0 1 0-11.145.026l.462.4.3-.532A5.516 5.516 0 0 1 12 15.5a5.515 5.515 0 0 1 4.794 2.802ZM12 13.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-6a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminCircle);
export default __webpack_public_path__ + "static/media/admin_circle.2920c566e9f4071e8dde0dddf81fb8a7.svg";
export { ForwardRef as ReactComponent };